import { ActionBanner, Button, TOUCH } from "@nymbl/nos2-rules";

/** Shown only while an ended week is unsigned (an alert is only shown when actionable). */
export function SignOffBanner({ count, onSignOff }: { count: number; onSignOff: () => void }) {
  if (count === 0) return null;
  return (
    <ActionBanner
      tone="danger"
      action={
        <Button variant="destructive" className={TOUCH} onClick={onSignOff}>
          Sign off past weeks
        </Button>
      }
    >
      {count === 1 ? "1 past week needs your sign-off" : `${count} past weeks need your sign-off`}
    </ActionBanner>
  );
}
